import Table from './Table'

export * from './styles'
export default Table
